import message from './Message';
export default message;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-message/src/index.js